/**
 * Galapagos public API route templates — the universal template set, bundled
 * into every client that initialises the web provider.
 *
 * GENERATED from `apps/api/src/openapi/public-routes.json` by
 * `scripts/generate-galapagos-api-routes.ts`. Do not edit by hand — run
 * `pnpm galapagos:routes`; `galapagos-api-routes.drift.test.ts` fails when this
 * drifts from the manifest.
 *
 * The manifest is method-prefixed (`GET /api/v1/…`) and the sanitiser sees no HTTP
 * method, so paths are de-duplicated across methods.
 *
 * Committed as a module rather than read from the JSON at runtime because this
 * ships in a browser bundle — and imported from neither `apps/api` nor any other
 * app, keeping the package free of an upward dependency (ADR-001 Rule 7).
 */
export const GALAPAGOS_API_ROUTE_TEMPLATES: readonly string[] = [
  '/api/v1/analytics/context',
  '/api/v1/app-update-policy',
  '/api/v1/assessments/v2/active',
  '/api/v1/assessments/v2/answers',
  '/api/v1/assessments/v2/start',
  '/api/v1/assessments/v2/{sessionId}/complete',
  '/api/v1/assessments/v2/{sessionId}/evaluate',
  '/api/v1/auth/demo-member',
  '/api/v1/auth/me',
  '/api/v1/auth/migration-demo-member',
  '/api/v1/auth/otp/initiate',
  '/api/v1/auth/otp/verify',
  '/api/v1/auth/preview-token',
  '/api/v1/auth/refresh',
  '/api/v1/auth/session-activity',
  '/api/v1/auth/sign-out',
  '/api/v1/bam/active',
  '/api/v1/bam/answers',
  '/api/v1/bam/questionnaire',
  '/api/v1/bam/start',
  '/api/v1/bam/{id}/complete',
  '/api/v1/bam/{id}/context',
  '/api/v1/care-chat/conversations',
  '/api/v1/care-chat/conversations/lookup',
  '/api/v1/care-chat/conversations/unread-count',
  '/api/v1/care-chat/conversations/{conversationId}/attachments',
  '/api/v1/care-chat/conversations/{conversationId}/attachments/{attachmentId}/commit',
  '/api/v1/care-chat/conversations/{conversationId}/attachments/{attachmentId}/url',
  '/api/v1/care-chat/conversations/{conversationId}/messages',
  '/api/v1/care-chat/conversations/{conversationId}/participants/{participantId}/presentation',
  '/api/v1/care-chat/conversations/{conversationId}/read',
  '/api/v1/care-team-interest/booking',
  '/api/v1/care-team-interest/responses',
  '/api/v1/care/appointments',
  '/api/v1/care/appointments/cancel',
  '/api/v1/care/appointments/reschedule',
  '/api/v1/care/appointments/slots',
  '/api/v1/care/appointments/slots/presentation',
  '/api/v1/care/appointments/{appointmentId}/details',
  '/api/v1/care/next-call',
  '/api/v1/care/overview',
  '/api/v1/check-ins',
  '/api/v1/check-ins/batch',
  '/api/v1/check-ins/context-catalog',
  '/api/v1/check-ins/custom-tags',
  '/api/v1/check-ins/custom-tags/{id}',
  '/api/v1/check-ins/{date}',
  '/api/v1/conversation-realtime/subscription-grant',
  '/api/v1/conversations',
  '/api/v1/conversations/{conversationId}',
  '/api/v1/conversations/{conversationId}/recording',
  '/api/v1/devices',
  '/api/v1/devices/current',
  '/api/v1/devices/push-permission',
  '/api/v1/eligibility/address-suggestions',
  '/api/v1/eligibility/checks',
  '/api/v1/eligibility/companies',
  '/api/v1/eligibility/registration-profile',
  '/api/v1/eligibility/saml/sessions',
  '/api/v1/eligibility/sponsors/{clientId}',
  '/api/v1/greeting',
  '/api/v1/healthie/webhooks',
  '/api/v1/home/guided-conversations',
  '/api/v1/home/guided-conversations/shown',
  '/api/v1/home/initial-review',
  '/api/v1/home/initial-review/complete',
  '/api/v1/home/initial-review/missing-check-ins',
  '/api/v1/home/initial-review/start',
  '/api/v1/home/journey-impressions',
  '/api/v1/home/presentation',
  '/api/v1/home/summary',
  '/api/v1/home/surface',
  '/api/v1/internal/access-grants',
  '/api/v1/internal/access-grants/volume',
  '/api/v1/internal/bam/assessments',
  '/api/v1/internal/bam/assessments/{assessmentId}',
  '/api/v1/internal/breathalyzer-readings',
  '/api/v1/internal/care-chat/conversations',
  '/api/v1/internal/care-chat/conversations/{conversationId}/attachments',
  '/api/v1/internal/care-chat/conversations/{conversationId}/attachments/{attachmentId}/commit',
  '/api/v1/internal/care-chat/conversations/{conversationId}/attachments/{attachmentId}/url',
  '/api/v1/internal/care-chat/conversations/{conversationId}/messages',
  '/api/v1/internal/care-chat/conversations/{conversationId}/read',
  '/api/v1/internal/check-ins',
  '/api/v1/internal/check-ins/{date}',
  '/api/v1/internal/intake',
  '/api/v1/internal/intake/summary',
  '/api/v1/internal/me',
  '/api/v1/internal/me/addresses',
  '/api/v1/internal/me/profile',
  '/api/v1/internal/me/profile/photo-uploads',
  '/api/v1/internal/members',
  '/api/v1/internal/members/detail-changes',
  '/api/v1/internal/members/eligibility-reviews',
  '/api/v1/internal/members/escalations',
  '/api/v1/internal/members/escalations/assignees',
  '/api/v1/internal/members/escalations/handled',
  '/api/v1/internal/members/escalations/handled/by-handler',
  '/api/v1/internal/members/escalations/{escalationId}',
  '/api/v1/internal/members/migration-status',
  '/api/v1/internal/members/minor-consent-markers',
  '/api/v1/internal/members/search',
  '/api/v1/internal/members/{ref}',
  '/api/v1/internal/members/{ref}/access',
  '/api/v1/internal/members/{ref}/addresses',
  '/api/v1/internal/members/{ref}/ai-notes',
  '/api/v1/internal/members/{ref}/call-recording',
  '/api/v1/internal/members/{ref}/care-appointments',
  '/api/v1/internal/members/{ref}/care-appointments/pending-attestation',
  '/api/v1/internal/members/{ref}/care-next-call',
  '/api/v1/internal/members/{ref}/care-pathway-tier',
  '/api/v1/internal/members/{ref}/care-team',
  '/api/v1/internal/members/{ref}/care-team/candidates',
  '/api/v1/internal/members/{ref}/care-team/{assignmentId}',
  '/api/v1/internal/members/{ref}/care-team/{assignmentId}/make-primary',
  '/api/v1/internal/members/{ref}/care-track',
  '/api/v1/internal/members/{ref}/check-in-calendar',
  '/api/v1/internal/members/{ref}/consents',
  '/api/v1/internal/members/{ref}/contact',
  '/api/v1/internal/members/{ref}/contact-case/close',
  '/api/v1/internal/members/{ref}/conversations',
  '/api/v1/internal/members/{ref}/detail-changes',
  '/api/v1/internal/members/{ref}/diagnoses',
  '/api/v1/internal/members/{ref}/documents/{documentId}/download-url',
  '/api/v1/internal/members/{ref}/eligibility',
  '/api/v1/internal/members/{ref}/eligibility/decisions',
  '/api/v1/internal/members/{ref}/emergency-clinics',
  '/api/v1/internal/members/{ref}/emergency-contacts',
  '/api/v1/internal/members/{ref}/emergency-details',
  '/api/v1/internal/members/{ref}/escalations/{escalationId}/assign',
  '/api/v1/internal/members/{ref}/escalations/{escalationId}/claim',
  '/api/v1/internal/members/{ref}/escalations/{escalationId}/comments',
  '/api/v1/internal/members/{ref}/escalations/{escalationId}/contact-attempts',
  '/api/v1/internal/members/{ref}/escalations/{escalationId}/history',
  '/api/v1/internal/members/{ref}/escalations/{escalationId}/manager-release',
  '/api/v1/internal/members/{ref}/escalations/{escalationId}/mark-handled',
  '/api/v1/internal/members/{ref}/escalations/{escalationId}/release',
  '/api/v1/internal/members/{ref}/escalations/{escalationId}/take-over',
  '/api/v1/internal/members/{ref}/goals/{goalId}',
  '/api/v1/internal/members/{ref}/healthie-link',
  '/api/v1/internal/members/{ref}/modules/{moduleKey}/completions',
  '/api/v1/internal/members/{ref}/modules/{moduleKey}/completions/{completionId}/void',
  '/api/v1/internal/members/{ref}/modules/{moduleKey}/progress',
  '/api/v1/internal/members/{ref}/modules/{moduleKey}/resets',
  '/api/v1/internal/members/{ref}/next-contact-due-date',
  '/api/v1/internal/members/{ref}/parental-consent',
  '/api/v1/internal/members/{ref}/programme-end',
  '/api/v1/internal/members/{ref}/push-status',
  '/api/v1/internal/members/{ref}/quit-date',
  '/api/v1/internal/members/{ref}/telemedicine-history',
  '/api/v1/internal/members/{ref}/telemedicine-history/{appointmentId}/transcript',
  '/api/v1/internal/members/{ref}/tobacco-surcharge',
  '/api/v1/internal/members/{ref}/treatment-plan-offer',
  '/api/v1/internal/members/{ref}/urine-test-results',
  '/api/v1/internal/notifications',
  '/api/v1/internal/notifications/check-in-reminder-preview',
  '/api/v1/internal/notifications/follow-up-preview',
  '/api/v1/internal/notifications/read-all',
  '/api/v1/internal/notifications/read-all-for-member',
  '/api/v1/internal/notifications/unread-counts',
  '/api/v1/internal/notifications/v2',
  '/api/v1/internal/notifications/v2/read-all',
  '/api/v1/internal/notifications/v2/read-all-for-member',
  '/api/v1/internal/notifications/v2/unread-counts',
  '/api/v1/internal/notifications/v2/{notificationId}/read',
  '/api/v1/internal/notifications/v2/{notificationId}/unread',
  '/api/v1/internal/notifications/{notificationId}/read',
  '/api/v1/internal/notifications/{notificationId}/unread',
  '/api/v1/internal/nrt-orders/{orderId}/approve',
  '/api/v1/internal/nrt-orders/{orderId}/items',
  '/api/v1/internal/nrt-orders/{orderId}/reject',
  '/api/v1/internal/nrt-orders/{orderId}/ship',
  '/api/v1/internal/nrt-requests',
  '/api/v1/internal/nrt-requests/{requestId}',
  '/api/v1/internal/orders/members/{memberId}',
  '/api/v1/internal/orders/{orderId}',
  '/api/v1/internal/orders/{orderId}/approve',
  '/api/v1/internal/orders/{orderId}/items',
  '/api/v1/internal/orders/{orderId}/reject',
  '/api/v1/internal/orders/{orderId}/ship',
  '/api/v1/internal/outreach',
  '/api/v1/internal/outreach/{id}',
  '/api/v1/internal/outreach/{id}/approve',
  '/api/v1/internal/outreach/{id}/cancel',
  '/api/v1/internal/outreach/{id}/edit',
  '/api/v1/internal/pharmacy-orders/members/{memberId}',
  '/api/v1/internal/pharmacy-orders/members/{memberId}/orders/{orderId}/handled',
  '/api/v1/internal/preview-token',
  '/api/v1/internal/rewards',
  '/api/v1/internal/rewards/manual-reward',
  '/api/v1/internal/rewards/redemptions/{id}/refund',
  '/api/v1/internal/rewards/visibility',
  '/api/v1/internal/teams',
  '/api/v1/internal/teams/{teamId}/members',
  '/api/v1/internal/teams/{teamId}/members/{internalUserId}',
  '/api/v1/internal/users',
  '/api/v1/internal/users/{internalUserId}',
  '/api/v1/internal/users/{internalUserId}/addresses',
  '/api/v1/internal/users/{internalUserId}/groups',
  '/api/v1/internal/users/{internalUserId}/profile',
  '/api/v1/internal/users/{internalUserId}/profile/photo-uploads',
  '/api/v1/locales',
  '/api/v1/members/me/care-preferences',
  '/api/v1/members/me/care-team',
  '/api/v1/members/me/consents',
  '/api/v1/members/me/consents/documents',
  '/api/v1/members/me/consents/{consentType}/document',
  '/api/v1/members/me/consents/{consentType}/document/preview',
  '/api/v1/members/me/documents/{documentId}/download-url',
  '/api/v1/members/me/eligibility',
  '/api/v1/members/me/hdhp-notice',
  '/api/v1/members/me/medication',
  '/api/v1/members/me/modules/{moduleKey}/content',
  '/api/v1/members/me/modules/{moduleKey}/progress',
  '/api/v1/members/me/modules/{moduleKey}/steps/{stepKey}/completion',
  '/api/v1/members/me/nrt-requests',
  '/api/v1/members/me/nrt-requests/current',
  '/api/v1/members/me/nrt-supply',
  '/api/v1/members/me/profile',
  '/api/v1/members/me/quit-date',
  '/api/v1/members/me/registration-consents',
  '/api/v1/members/me/registration-profile',
  '/api/v1/members/me/signup-resume',
  '/api/v1/members/me/substance-config',
  '/api/v1/members/me/tobacco-surcharge',
  '/api/v1/messages',
  '/api/v1/messages/{message}',
  '/api/v1/migration/authenticate',
  '/api/v1/migration/start',
  '/api/v1/migration/status',
  '/api/v1/migration/summary',
  '/api/v1/notifications/preferences',
  '/api/v1/notifications/preferences/{categoryKey}',
  '/api/v1/onboarding/sessions/app-setup',
  '/api/v1/onboarding/sessions/app-setup/commands',
  '/api/v1/onboarding/sessions/app-setup/questionnaire-completion',
  '/api/v1/onboarding/sessions/config/usage',
  '/api/v1/onboarding/sessions/setup',
  '/api/v1/onboarding/sessions/setup/commands',
  '/api/v1/onboarding/sessions/{flowId}',
  '/api/v1/onboarding/sessions/{flowId}/answers',
  '/api/v1/onboarding/sessions/{flowId}/feedback',
  '/api/v1/openapi.json',
  '/api/v1/reminders',
  '/api/v1/reminders/{reminderId}',
  '/api/v1/rewards/cm-eligibility',
  '/api/v1/rewards/history',
  '/api/v1/rewards/ledger',
  '/api/v1/rewards/products',
  '/api/v1/rewards/redemption-review',
  '/api/v1/rewards/redemptions',
  '/api/v1/rewards/redemptions/{id}',
  '/api/v1/rewards/status',
  '/api/v1/rum-intake',
  '/api/v1/status',
  '/api/v1/telemedicine/adhoc-calls',
  '/api/v1/telemedicine/adhoc-calls/availability',
  '/api/v1/telemedicine/appointments',
  '/api/v1/telemedicine/appointments/cancel',
  '/api/v1/telemedicine/appointments/progress-purpose-defaults',
  '/api/v1/telemedicine/appointments/reschedule',
  '/api/v1/telemedicine/appointments/slots',
  '/api/v1/telemedicine/appointments/{appointmentId}/ai-notes',
  '/api/v1/telemedicine/appointments/{appointmentId}/attendance',
  '/api/v1/telemedicine/appointments/{appointmentId}/modality',
  '/api/v1/telemedicine/calls',
  '/api/v1/telemedicine/calls/active',
  '/api/v1/telemedicine/calls/decline',
  '/api/v1/telemedicine/calls/end',
  '/api/v1/telemedicine/calls/feedback',
  '/api/v1/telemedicine/calls/heartbeat',
  '/api/v1/telemedicine/calls/{callSessionId}/presentation',
  '/api/v1/telemedicine/care-staffing/internal-users/{internalUserId}/specialist',
  '/api/v1/telemedicine/care-staffing/me/specialist',
  '/api/v1/telemedicine/care-staffing/policies/{callType}',
  '/api/v1/telemedicine/care-staffing/roster',
  '/api/v1/telemedicine/care-staffing/roster/full-coverage-matrix',
  '/api/v1/telemedicine/care-staffing/specialists/{specialistId}/coverage/{callType}',
  '/api/v1/telemedicine/care-staffing/specialists/{specialistId}/default-pool',
  '/api/v1/telemedicine/care-staffing/specialists/{specialistId}/licences',
  '/api/v1/telemedicine/care-staffing/specialists/{specialistId}/prescriber-details',
  '/api/v1/telemedicine/meetings',
  '/api/v1/telemedicine/specialists',
  '/api/v1/voice-tools/build-practice',
  '/api/v1/voice-tools/get-check-ins',
  '/api/v1/voice-tools/search-help',
  '/api/v1/voice/consent',
  '/api/v1/voice/elevenlabs/credentials',
  '/api/v1/voice/post-call',
  '/api/v1/voice/preference',
  '/api/v1/voice/sessions',
  '/api/v1/voice/sessions/{sessionId}/ended',
  '/api/v1/voice/voices',
  '/api/v1/weekly-plan/suggestions',
  '/api/v1/weekly-plan/topics',
];
